import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { get } from "lodash";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { destroy as removeItemFromCart } from "APP_ROOT/Nav/RepairOrdersCart/actions";
import { addItemToCartAndRefreshList } from "MODULES/RepairOrders/actions";
import {
  INVENTORIES,
  QC_HOLD,
  UNDER_REVIEW
} from "MODULES/inventories/constants";
import {
  DataTable,
  SearchPropTypes,
  PoCode,
  PartNumber
} from "MODULES/shared/components";
import StatusTags from "MODULES/Receiving/components/shared/StatusTags";
import LocationFlag from "MODULES/shared/components/LocationFlag/LocationFlag";
import { shortDate } from "LIB/formatters/date";
import { ADMIN, ROLE, USER } from "MODULES/users/constants";
import { ID } from "APP_ROOT/constants";
import { truncate, getFirstNameLastInitial } from "LIB/formatters/text";

const statuses = item => ({
  discrepancies: !item.discrepancies_resolved,
  hold: item.qc_status === QC_HOLD,
  underReview: item.qc_status === UNDER_REVIEW
});

export default function Table({ results, isLoading }) {
  const reference = item => {
    if (item.lot_id) {
      return (
        <Link to={`/lots/${get(item, "lot_details.uuid")}`}>
          {get(item, "lot_details.code")}{" "}
        </Link>
      );
    } else if (item.exchange_eval_in_progress) {
      return (
        <Link to={`/sales-orders/${get(item, "most_recent_sales_order.id")}`}>
          {get(item, "most_recent_sales_order.code")}{" "}
        </Link>
      );
    } else if (
      item.customer_rma_request_in_progress ||
      item.customer_rma_for_received_exchange_in_progress
    ) {
      return (
        <Link to={`/rmas/${get(item, "most_recent_customer_rma.id")}`}>
          {get(item, "most_recent_customer_rma.code")}{" "}
        </Link>
      );
    } else if (item.managed_repair_in_progress) {
      return (
        <Link
          to={`/managed-repair-orders/${get(
            item,
            "managed_repair_details.uuid"
          )}`}
        >
          {get(item, "managed_repair_details.code")}{" "}
        </Link>
      );
    }

    return <PoCode inventory={item} />;
  };

  const renderRow = item => (
    <tr
      className={classNames({ "text-muted": item.cart })}
      key={`repair-list-item-${item.id}`}
    >
      <td>{shortDate(item.reserved_for_repair_on)}</td>
      <td>
        <PartNumber part={item.part} />
      </td>
      <td>
        <Link to={`/inventories/${item.uuid}`}>{item.serial_number}</Link>
      </td>
      <td>{shortDate(item.date_received)}</td>
      <td>{reference(item)}</td>
      <td>{truncate(item.part.description, 25)}</td>
      <td>
        <LocationFlag
          location={item.store_owner_id}
          consignment_type={item.consignment_type}
        />
      </td>
      <td>
        <LocationFlag location={item.store_location_id} />
      </td>
      <td>{INVENTORIES.condition[item.condition].label}</td>
      <td>{item.total_quantity}</td>
      <td>
        <StatusTags {...statuses(item)} />
      </td>
      <td>{item.cart && getFirstNameLastInitial(item.cart.full_name)}</td>
      <td className="text-center td-shrink-icon">
        <ConnectedButton reservedBy={item.cart} inventoryId={item.id} />
      </td>
    </tr>
  );

  return (
    <DataTable loading={isLoading}>
      <DataTable.Head>
        <th>Reserved at</th>
        <th>Part #</th>
        <th>Serial #</th>
        <th>Date Received</th>
        <th>REF #</th>
        <th>Description</th>
        <th>Store Owner</th>
        <th>Store Loc</th>
        <th>Condition</th>
        <th>QTY</th>
        <th>Status</th>
        <th>In Cart</th>
        <th className="text-center" />
      </DataTable.Head>
      <DataTable.Body>{results.map(renderRow)}</DataTable.Body>
    </DataTable>
  );
}

Table.propTypes = {
  ...SearchPropTypes
};

const CartButton = ({ reservedBy, handleClick, currentUser }) => {
  const isAdmin = currentUser.get(ROLE) === ADMIN;
  const inCart = !!reservedBy;

  const notDisabled =
    isAdmin || (reservedBy && reservedBy.id === currentUser.get(ID));

  const removalText = notDisabled ? "Remove From Cart" : "In Cart";
  const text = inCart ? removalText : "Add to Cart";

  const classes = classNames(
    "btn btn-xs btn-hollow",
    classNames({
      "text-muted": inCart,
      "btn-primary": !inCart,
      "btn-default": inCart
    })
  );

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={!!inCart && !notDisabled}
      className={classes}
    >
      {text}
    </button>
  );
};

CartButton.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  reservedBy: PropTypes.shape({}),
  handleClick: PropTypes.func.isRequired
};

export const ConnectedButton = connect(
  state => ({
    currentUser: state.session.get(USER)
  }),
  (dispatch, ownProps) => ({
    handleClick: () =>
      ownProps.reservedBy
        ? dispatch(removeItemFromCart(ownProps.inventoryId))
        : dispatch(addItemToCartAndRefreshList(ownProps.inventoryId))
  })
)(CartButton);



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/ReserveForRepair/Table.jsx